module.exports = __webpack_public_path__ + "public/img/yibiaopan_lv_22.d30c8513.png";